<template>
	<button
		class="checkout-cart-button"
		:class="{
			'checkout-cart-button--sticky': sticky,
		}"
		type="button"
		@click="onClick"
	>
		<span
			class="checkout-cart-button__total"
			v-html="$options.filters.madpricecent(total)"
		/>
		<span
			class="checkout-cart-button__count"
			v-html="$t('checkout.itemCount', { number: totalItemsWithoutAdditional })"
		/>
	</button>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from 'htmlcomponent'

export default {
	props: {
		sticky: Boolean
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters("cart", [
			"total",
			"totalItemsWithoutAdditional",
		]),
	},
	methods: {
		onClick() {
			htmlComponent.send('overlay:open', {type: 'sidebar-cart'});
		},
	}
}
</script>

<style>

</style>
